import { Article } from 'components/commons/Article';
import React from 'react';
import { Header } from './Header/Header';
import { Section1 } from './Section1/Section1';
import { Section2 } from './Section2/Section2';

export const Contact = () => {
  return (
    <Article flexDirection="column">
      <Header />
      <Section1 />
      <Section2 />
    </Article>
  );
};
